import { createTheme } from '@mui/material/styles';

export const BRAND_COLORS = {
  primary: '#6B3F1D',
  primaryDark: '#4A2A14',
  primaryLight: '#8B5A2B',
  secondary: '#F5E6D3',
};

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: BRAND_COLORS.primary,
      dark: BRAND_COLORS.primaryDark,
      light: BRAND_COLORS.primaryLight,
    },
    secondary: {
      main: BRAND_COLORS.secondary,
    },
    background: {
      default: '#FAF7F2',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#3A2312',
      secondary: '#6D4C2E',
    },
  },

  typography: {
    fontFamily: `'Poppins', 'Roboto', 'Arial', sans-serif`,
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 600 },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },

  shape: {
    borderRadius: 10,
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          padding: '10px 20px',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: BRAND_COLORS.primary,
        },
      },
    },
  },
});

export default theme;